import {
	type Alert,
	type NewSNRPredictionType,
	type SNRActionType,
} from '@atlassian/eoc-alert-common';
import { fetch } from '@atlassian/eoc-fetch';

import { type EntityRelationTypeResponse, type LogTypeResponse } from '../../common/types';

import { type ResponderStatesResponse } from './types';

export const getAlertDetail = (alertId: string) => fetch<Alert>(`/v1/alerts/${alertId}`);

export const getAlertLogTypesEndpoint = () => fetch<LogTypeResponse>(`/v1/alerts/logs/types`);

export const getResponderStatesEndpoint = (alertId: string) =>
	fetch<ResponderStatesResponse>(`/v1/alerts/${alertId}/responder-states`);

export const getEntityRelationTypesEndpoint = (alertId: string) =>
	fetch<EntityRelationTypeResponse>(`/v1/alerts/${alertId}/entity-relations/relation-types`).then(
		(res) => ({
			relationTypes: res.relationTypes.sort((a, b) => a.label.localeCompare(b.label)),
		}),
	);

export const updateAlertSNRDetails = ({
	id,
	prevPrediction,
	newPrediction,
	action,
}: {
	action: SNRActionType;
	id: string;
	newPrediction: NewSNRPredictionType;
	prevPrediction: NewSNRPredictionType;
}) => {
	return fetch<{
		failedRecords?: number;
		snrResponse: Alert | null;
	}>(`/v1/alerts-insights/${id}/snr-prediction-action`, {
		method: 'POST',
		body: {
			id,
			type: 'alert',
			prevPrediction,
			newPrediction,
			action,
		},
		exactUrl: true,
	});
};
